import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./index.css";

// Components Imports
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown";
import CommonCalendar from "../../_utils/CommonCalendar";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import TEXT from "../../../utils/globalText";

const MISReportCreateSelection = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setShowDatePicker,
  setIsDateConfirmed,
  setSelectedOption,
  selectedOption,
  setIsDropdownOpen,
  isDropdownOpen,
  setstartDateConfirm,
  setendDateConfirm,
}) => {
  const location = useLocation();

  const fieldDropdownRef = useRef(null);
  const datePickerRef = useRef(null);

  const Mis_CatergoriesAccData = [
    TEXT?.BENEFICIARY_TRANSACTION,
    TEXT?.INTERNAL_TRANSACTION,
    TEXT?.USER,
    TEXT?.BANK_STATEMENT,
    // "Private transaction",
  ];

  const handleDateChange2 = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    setIsDateConfirmed(true);
    setstartDateConfirm(start ? new Date(start) : null);
    setendDateConfirm(end ? new Date(end) : null);

    setShowDatePicker(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutsideField =
        fieldDropdownRef.current &&
        !fieldDropdownRef.current.contains(event.target);
      const isOutsideDate =
        datePickerRef.current && !datePickerRef.current.contains(event.target);

      if (isOutsideField) {
        setIsDropdownOpen(false);
      }
      if (isOutsideDate) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setIsDropdownOpen, setShowDatePicker]);

  useEffect(() => {
    if (selectedOption) return;
    const path = location.pathname;

    switch (true) {
      case path.includes("beneficiary_transaction_dashboard"):
        setSelectedOption(TEXT?.BENEFICIARY_TRANSACTION);
        break;

      case path.includes("internal_transaction_dashboard"):
        setSelectedOption(TEXT?.INTERNAL_TRANSACTION);
        break;

      case path.includes("owner_account_dashboard"):
        setSelectedOption(TEXT?.BANK_STATEMENT);
        break;

      case path.includes("private_transaction_dashboard"):
        setSelectedOption(TEXT?.PRIVATE_TRANSACTION);
        break;

      default:
        setSelectedOption("");
        break;
    }
  }, [location.pathname]);

  return (
    <>
      <div className={`Mis_report_Main_div`}>
        <div
          style={{
            maxWidth: "var(--max-content-width)",
          }}
          className="w-width-full flex flex-col Qsmd:flex-row justify-center gap-gap-md Qsmd:gap-gap-xl"
        >
          <div className="Mis_report_SelectAcc_div_owner">
            <div className="flex flex-col gap-y-gap-md relative h-fit">
              <TitleSubtitlePair
                title={TEXT?.FIELD}
                subtitle={TEXT?.SELECT_THE_FIELD_TO_GENERATE_THE_MIS_REPORT}
                variant="md"
                titleColor="text-primary"
                isBold={true}
              />

              <div
                ref={fieldDropdownRef}
                className={`${isDropdownOpen ? "open" : ""}`}
                onClick={() => {
                  setIsDropdownOpen(!isDropdownOpen);
                  if (!isDropdownOpen) {
                    setShowDatePicker(false);
                  }
                }}
              >
                <SingleSelectDropDownComponent
                  options={Mis_CatergoriesAccData}
                  selected={selectedOption}
                  setSelected={setSelectedOption}
                  isOpen={false}
                  showSearch={false}
                  placeholder={TEXT?.SELECT_FIELD}
                  searchPlaceholder={TEXT?.SEARCH}
                  disabled={false}
                  type="big"
                />
              </div>
            </div>
          </div>

          <div className="h-fit w-width-full Qsmd:w-width-md  relative p-padding-md rounded-border-radius-md bg-primary-card ">
            <div className="flex flex-col gap-gap-md relative">
              <TitleSubtitlePair
                title={TEXT?.DATE_RANGE}
                subtitle={TEXT?.SELECT_A_DATE_RANGE_TO_GENERATE_THE_MIS_REPORT}
                variant="md"
                titleColor="text-primary"
                isBold={true}
              />

              <CommonCalendar
                startDate={startDate}
                endDate={endDate}
                handleDateChange={handleDateChange2}
                type="big"
                selectionType="range"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MISReportCreateSelection;
